import { gql } from '@apollo/client';

import { SaasCredentialBaseFields } from './saasCredentials.fragment';

export * from './saasCredentials.query.generated';

export const SAAS_CREDENTIALS = gql`
  ${SaasCredentialBaseFields}
  query saasCredentials(
    $saasEscrowId: ID!
    $credentialType: CredentialTypeEnum
    $orderBy: SaasCredentialsOrderByEnum
    $order: QueryOrderEnum
    $query: String
    $ids: [ID!]
    $page: Int
    $perPage: Int
  ) {
    saasCredentials(
      saasEscrowId: $saasEscrowId
      credentialType: $credentialType
      orderBy: $orderBy
      order: $order
      query: $query
      ids: $ids
      page: $page
      perPage: $perPage
    ) {
      nodes {
        ...SaasCredentialBaseFields
      }
      nodesCount
      pagesCount
    }
  }
`;
